var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChipWrapper } from './styled';
import Typography from '../Typography';
import Loader from '../Loader';
import Icon from '../Icon';
const Chip = (_a) => {
    var props = __rest(_a, []);
    const { color = '#FFF', label, loading, disabled, iconName, variant, loaderCustomColor, hideIcon } = props, rest = __rest(props, ["color", "label", "loading", "disabled", "iconName", "variant", "loaderCustomColor", "hideIcon"]);
    if (!label) {
        return (_jsx(ChipWrapper, Object.assign({}, rest, { disabled: disabled, variant: variant, label: label, color: color }, { children: loading ? (_jsx(Loader, { size: 12, pointRadio: "4px", 
                // eslint-disable-next-line no-nested-ternary
                color: variant === 'dark' ? '#FFF' : loaderCustomColor ? color : null })) : (_jsx(Icon, { name: iconName !== null && iconName !== void 0 ? iconName : 'dotSpecial', color: color, size: "12px" })) })));
    }
    return (_jsxs(ChipWrapper, Object.assign({}, rest, { disabled: disabled, variant: variant, label: label, color: color }, { children: [loading && (_jsx(Loader, { size: 12, pointRadio: "4px", 
                // eslint-disable-next-line no-nested-ternary
                color: variant === 'dark' ? '#FFF' : loaderCustomColor ? color : null })), !loading && !hideIcon && _jsx(Icon, { name: iconName !== null && iconName !== void 0 ? iconName : 'dotSpecial', color: color, size: "12px" }), _jsx(Typography, Object.assign({ fontSize: 12, color: color, style: { fontWeight: 400, lineHeight: 1.4 } }, { children: label })), (!disabled || loading) && _jsx(Icon, { name: "closeOutlined", color: color, size: "12px" })] })));
};
Chip.defaultProps = {
    variant: 'dark',
    color: '#FFF',
    backgroundColor: '#1F89FF',
    iconPosition: 'left',
    disabled: false,
    loading: false,
};
export default Chip;
//# sourceMappingURL=index.js.map